import { apiRequest } from './auth';

export const dashboardAPI = {
  // Pobierz wszystkie karty dla projektu
  getByProject: async (project, date = null) => {
    const url = date 
      ? `/dashboard/${encodeURIComponent(project)}?date=${encodeURIComponent(date)}`
      : `/dashboard/${encodeURIComponent(project)}`;
    return await apiRequest(url);
  },

  // Pobierz wszystkie karty dla użytkownika
  getAll: async (date = null) => {
    const url = date 
      ? `/dashboard?date=${encodeURIComponent(date)}`
      : '/dashboard';
    return await apiRequest(url);
  },

  // Utwórz lub zaktualizuj kartę
  upsert: async (cardData) => {
    return await apiRequest('/dashboard', {
      method: 'POST',
      body: JSON.stringify(cardData),
    });
  },

  // Zaktualizuj kartę
  update: async (id, cardData) => {
    return await apiRequest(`/dashboard/${id}`, {
      method: 'PUT',
      body: JSON.stringify(cardData),
    });
  },

  // Usuń kartę
  delete: async (id) => {
    return await apiRequest(`/dashboard/${id}`, {
      method: 'DELETE',
    });
  }
};

export default dashboardAPI;
